(function () {
  'use strict';
  if (!document.body || !document.body.classList.contains('arn-v6')) {
    // Defer until body has the class
    document.addEventListener('DOMContentLoaded', function () {
      if (document.body.classList.contains('arn-v6')) boot();
    });
    return;
  }
  boot();

  function boot() {
    /* ============ LOADER ============ */
    var loader = document.getElementById('arnv6Loader');

    function dismissLoader() {
      setTimeout(function () {
        if (loader) {
          loader.style.transition = 'transform 1.1s cubic-bezier(0.22,1,0.36,1), opacity 0.4s ease 0.7s';
          loader.style.transform = 'translateY(-100%)';
          loader.style.opacity = '0';
          loader.style.pointerEvents = 'none';
          setTimeout(function () {
            loader.style.display = 'none';
          }, 1500);
        }
        setTimeout(function () {
          var hero = document.querySelector('body.arn-v6 .hero');
          if (hero) {
            var parts = hero.querySelectorAll('[data-word-split] .split-line, .fade-up');
            parts.forEach(function (el, i) {
              setTimeout(function () { el.classList.add('in'); }, i * 80);
            });
            hero.classList.add('in');
          }
        }, 700);
      }, 1000);
    }

    // If the page has already finished loading (load event already fired),
    // dismiss immediately. Otherwise wait for it.
    if (document.readyState === 'complete') {
      dismissLoader();
    } else {
      window.addEventListener('load', dismissLoader);
    }

    /* ============ WORD SPLIT ============ */
    document.querySelectorAll('body.arn-v6 [data-word-split]').forEach(function (el) {
      if (el.dataset.wordSplitInit) return;
      var text = el.textContent;
      var words = text.split(' ');
      el.innerHTML = words.map(function (w) {
        return '<span class="split-line"><span class="split-word">' + w + '</span></span>';
      }).join(' ');
      el.dataset.wordSplitInit = '1';
    });

    /* ============ INTERSECTION REVEAL ============ */
    var revealObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          if (entry.target.classList.contains('panel')) entry.target.classList.add('in');
          entry.target.querySelectorAll('.split-line').forEach(function (line, i) {
            setTimeout(function () { line.classList.add('in'); }, i * 70);
          });
          entry.target.querySelectorAll('.fade-up').forEach(function (el) { el.classList.add('in'); });
          revealObs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -80px 0px' });
    document.querySelectorAll('body.arn-v6 .panel').forEach(function (p) { revealObs.observe(p); });

    /* ============ COUNT-UP ============ */
    var countObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var el = entry.target;
          var target = parseFloat(el.dataset.count);
          var suffix = el.dataset.suffix || '';
          var isDecimal = target % 1 !== 0;
          var duration = 1600;
          var start = performance.now();
          (function step(now) {
            var t = Math.min((now - start) / duration, 1);
            var eased = 1 - Math.pow(1 - t, 3);
            var val = eased * target;
            el.textContent = (isDecimal ? val.toFixed(1) : Math.floor(val)) + suffix;
            if (t < 1) requestAnimationFrame(step);
            else el.textContent = (isDecimal ? target.toFixed(1) : target) + suffix;
          })(start);
          countObs.unobserve(el);
        }
      });
    }, { threshold: 0.4 });
    document.querySelectorAll('body.arn-v6 [data-count]').forEach(function (el) { countObs.observe(el); });

    /* ============ PARALLAX ============ */
    var heroBgImage = document.getElementById('arnv6HeroBgImage');
    var parallaxEls = document.querySelectorAll('body.arn-v6 [data-parallax]');
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      if (heroBgImage) {
        var scale = 1 + Math.min(y / 2000, 0.1);
        heroBgImage.style.transform = 'translate3d(0,' + (y * 0.25) + 'px,0) scale(' + scale + ')';
      }
      parallaxEls.forEach(function (el) {
        var rect = el.parentElement.getBoundingClientRect();
        var visible = rect.top < window.innerHeight && rect.bottom > 0;
        if (visible) {
          var offset = (rect.top - window.innerHeight / 2) * -0.08;
          el.style.transform = 'translate3d(0,' + offset + 'px,0)';
        }
      });
    }, { passive: true });

    /* ============ STICKY BAR ============ */
    var stickyBar = document.getElementById('arnv6StickyBar');
    var heroEl = document.querySelector('body.arn-v6 .hero');
    if (stickyBar && heroEl) {
      var stickyObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting && entry.boundingClientRect.top < 0) stickyBar.classList.add('show');
          else stickyBar.classList.remove('show');
        });
      }, { threshold: 0 });
      stickyObs.observe(heroEl);
    }

    /* ============ LIVE SESSIONS ============ */
    var sessionsEl = document.getElementById('arnv6SessionsCount');
    if (sessionsEl) {
      var sessions = 5247;
      (function tick() {
        var r = Math.random();
        var add = 1;
        if (r > 0.92) add = Math.floor(Math.random() * 4) + 2;
        sessions += add;
        sessionsEl.textContent = sessions.toLocaleString();
        setTimeout(tick, 1800 + Math.random() * 4200);
      })();
    }

    /* ============ RIDERS PROGRESS ============ */
    var ridersTrack = document.getElementById('arnv6RidersTrack');
    var ridersProgressFill = document.getElementById('arnv6RidersProgressFill');
    var ridersPos = document.getElementById('arnv6RidersPos');
    if (ridersTrack && ridersProgressFill && ridersPos) {
      ridersTrack.addEventListener('scroll', function () {
        var max = ridersTrack.scrollWidth - ridersTrack.clientWidth;
        var progress = max > 0 ? ridersTrack.scrollLeft / max : 0;
        ridersProgressFill.style.width = (33 + progress * 67) + '%';
        var idx = Math.round(progress * 2) + 1;
        ridersPos.textContent = String(idx).padStart(2, '0') + ' / 03';
      }, { passive: true });
    }

    /* ============ SCISSORS CURSOR — SMOOTHED ============
       Per brief: rAF lerp + translate3d + shortest-path angle wrap.
       POS_SMOOTH 0.35, ROT_SMOOTH 0.18.
       ==================================================== */
    var isHoverPointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (!isHoverPointer) return; // No cursor on touch devices

    var cursor = document.getElementById('arnv6Cursor');
    var cursorLabel = document.getElementById('arnv6CursorLabel');
    var bladeTop = document.getElementById('arnv6BladeTop');
    var bladeBottom = document.getElementById('arnv6BladeBottom');
    var trailCanvas = document.getElementById('arnv6CutTrail');
    if (!cursor || !trailCanvas) return;
    var ctx = trailCanvas.getContext('2d');

    var POS_SMOOTH = 0.35;
    var ROT_SMOOTH = 0.18;
    var TRAIL_LIFE = 600; // ms

    // Target (raw mouse) + Displayed (lerped) positions
    var mouseX = window.innerWidth / 2;
    var mouseY = window.innerHeight / 2;
    var dispX = mouseX;
    var dispY = mouseY;
    var lastMouseX = mouseX;
    var lastMouseY = mouseY;

    var targetRot = -15; // degrees
    var dispRot = -15;
    var trailPoints = [];

    function resizeTrail() {
      trailCanvas.width = window.innerWidth;
      trailCanvas.height = window.innerHeight;
    }
    resizeTrail();
    window.addEventListener('resize', resizeTrail);

    // Snip state
    var snipping = false;
    var snipPhase = 0;
    var snipDir = 0;
    var breathT = 0;

    window.addEventListener('mousemove', function (e) {
      mouseX = e.clientX;
      mouseY = e.clientY;
      var dx = mouseX - lastMouseX;
      var dy = mouseY - lastMouseY;
      var dist = Math.hypot(dx, dy);
      if (dist > 2) {
        var angle = Math.atan2(dy, dx) * 180 / Math.PI;
        targetRot = angle - 90;
      }
      lastMouseX = mouseX;
      lastMouseY = mouseY;
      if (dist > 4) {
        trailPoints.push({ x: mouseX, y: mouseY, t: performance.now() });
      }
    }, { passive: true });

    window.addEventListener('mousedown', function () { snipDir = 1; });
    window.addEventListener('mouseup', function () { snipDir = -1; });

    // Shortest-path angle wrap: lerp toward target by the short way around the circle
    function shortestAngleLerp(current, target, t) {
      var diff = ((target - current + 540) % 360) - 180;
      return current + diff * t;
    }

    function animate() {
      // Position lerp
      dispX += (mouseX - dispX) * POS_SMOOTH;
      dispY += (mouseY - dispY) * POS_SMOOTH;
      dispRot = shortestAngleLerp(dispRot, targetRot, ROT_SMOOTH);

      cursor.style.transform =
        'translate3d(' + dispX + 'px,' + dispY + 'px,0) translate(-50%,-50%) rotate(' + dispRot + 'deg)';

      if (cursorLabel) {
        cursorLabel.style.transform =
          'translate3d(' + (dispX + 28) + 'px,' + (dispY + 18) + 'px,0)';
      }

      // Snip phase
      if (snipping) {
        breathT += 0.05;
        snipPhase = (Math.sin(breathT) + 1) / 2 * 0.6;
      } else if (snipDir !== 0) {
        snipPhase += 0.15 * snipDir;
        if (snipPhase >= 1) { snipPhase = 1; snipDir = -1; }
        if (snipPhase <= 0) { snipPhase = 0; snipDir = 0; }
      } else {
        snipPhase *= 0.85;
        if (snipPhase < 0.01) snipPhase = 0;
      }
      var closeAngle = snipPhase * 28;
      if (bladeTop && bladeBottom) {
        bladeTop.setAttribute('transform', 'rotate(' + closeAngle + ' 16 16)');
        bladeBottom.setAttribute('transform', 'rotate(' + (-closeAngle) + ' 16 16)');
      }

      // Trail
      ctx.clearRect(0, 0, trailCanvas.width, trailCanvas.height);
      var now = performance.now();
      trailPoints = trailPoints.filter(function (p) { return now - p.t < TRAIL_LIFE; });
      if (trailPoints.length > 1) {
        ctx.lineCap = 'round';
        ctx.lineJoin = 'round';
        for (var i = 1; i < trailPoints.length; i++) {
          var p1 = trailPoints[i - 1];
          var p2 = trailPoints[i];
          var age = (now - p2.t) / TRAIL_LIFE;
          var alpha = (1 - age) * 0.35;
          ctx.strokeStyle = 'rgba(225, 6, 0, ' + alpha + ')';
          ctx.lineWidth = (1 - age) * 1.5;
          ctx.setLineDash([3, 4]);
          ctx.beginPath();
          ctx.moveTo(p1.x, p1.y);
          ctx.lineTo(p2.x, p2.y);
          ctx.stroke();
        }
        ctx.setLineDash([]);
      }

      requestAnimationFrame(animate);
    }
    requestAnimationFrame(animate);

    // Cursor label + snip activation
    document.querySelectorAll('body.arn-v6 [data-cursor]').forEach(function (el) {
      el.addEventListener('mouseenter', function () {
        if (cursorLabel) {
          cursorLabel.textContent = el.dataset.cursor;
          cursorLabel.classList.add('show');
        }
        snipping = true;
        breathT = 0;
      });
      el.addEventListener('mouseleave', function () {
        if (cursorLabel) cursorLabel.classList.remove('show');
        snipping = false;
      });
    });

    /* ============ LAYER HOVER LIGHT ============ */
    document.querySelectorAll('body.arn-v6 .layer').forEach(function (card) {
      card.addEventListener('mousemove', function (e) {
        var rect = card.getBoundingClientRect();
        var x = ((e.clientX - rect.left) / rect.width) * 100;
        var y = ((e.clientY - rect.top) / rect.height) * 100;
        card.style.setProperty('--mx', x + '%');
        card.style.setProperty('--my', y + '%');
      });
    });

    /* ============ MOBILE MENU ============ */
    var menuToggle = document.getElementById('arnv6MenuToggle');
    var mobileMenu = document.getElementById('arnv6MobileMenu');
    if (menuToggle && mobileMenu) {
      menuToggle.addEventListener('click', function () {
        mobileMenu.classList.toggle('open');
      });
      // Close menu when a link is tapped
      mobileMenu.querySelectorAll('a').forEach(function (a) {
        a.addEventListener('click', function () { mobileMenu.classList.remove('open'); });
      });
    }
  }
})();
